<template>
  <Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide :mask="false" draggable class="single_edit_add"  width="700">
    <div class="single_input">
      <div class="font_style_set"><span style="color: red">*</span>号码:</div>
      <Input v-model="telNumber" placeholder="请输入号码"/>
    </div>
    <div class="single_input">
      <div class="font_style_set"><span style="color: red">*</span>是否全局VIP:</div>
      <RadioGroup v-model="flagGlobal" type="button" placeholder="请选择是否全局VIP" title="是否全局VIP">
        <Radio v-for="(option, index) in isMemberList" :label="option.id" :key="index">{{option.name}}</Radio>
      </RadioGroup>
    </div>
    <div class="single_input" v-if="flagGlobal=='0'">
      <div class="font_style_set"><span style="color: red">*</span>技能组:</div>
      <Select v-model="queueNum" placeholder="请选择技能组" multiple>
        <OptionGroup label="普通技能组">
          <Option v-for="(option, index) in queueList" :value="option.id" :key="`normal`+index+option.queueName">{{option.queueName}}</Option>
        </OptionGroup>
        <OptionGroup label="AI技能组">
          <Option v-for="(option, index) in queueList2" :value="option.id" :key="`ai`+index+option.queueName">{{option.queueName}}</Option>
        </OptionGroup>
      </Select>
    </div>
    <div class="btn_template">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="save()">确认</Button>
    </div>
  </Modal>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    export default {
      name: "MemberEditOrAddPop",
      mixins:[publicFunClass],
      props:{
        showMemberEditOrAdd:Boolean,
        phone:String,
        isGlobal:String,
        queueId:String,
        vipId:String
      },
      data(){
        return{
          model:false,
          title:'添加VIP',
          telNumber:'',
          queueNum:[],
          flagGlobal:'0',
          queueList:[],
          queueList2:[],
          isMemberList: [{'id': '0', 'name': '否'}, {'id': '1', 'name': '是'}]
        }
      },
      methods:{
        cancel:function () {
          this.$emit("closeMemberEditOrAdd",false)
        },
        save:function () {
          let that=this;
          if (!this.telNumber){
            this.$Message.info("号码不能为空");
            return false;
          }
          if (!this.flagGlobal){
            this.$Message.info("请选择是否全局VIP");
            return false;
          }
          if (this.flagGlobal=='0' && this.queueNum.length==0){
            this.$Message.info("技能组号码不能为空");
            return false;
          }
          let menuId="3_5-5-1";
          if(this.vipId){
            menuId="3_5-5-2";
          }
          let param={
            telNumber:this.telNumber,
            queueId:this.queueNum.toString(),
            flagGlobal:this.flagGlobal,
            journalType:"CTI配置=>VIP管理=>"+ this.title,
            menuId:menuId,
            id:this.vipId
          };
          this.$http.post("vipNumber/doSave.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$alert(res.data.msg, '提示', {
                confirmButtonText: '确定'
              });
              return false;
            }
            that.$alert(res.data.msg, '提示', {
              confirmButtonText: '确定'
            });
            that.$emit("closeMemberEditOrAdd",true)
          })
        }
      },
      watch:{
        showMemberEditOrAdd:function () {
         this.model=this.showMemberEditOrAdd;
         this.title="添加VIP";
         if(this.showMemberEditOrAdd){
           this.getQueue("3");
           this.telNumber=this.phone;
           this.flagGlobal=this.isGlobal;
           this.queueNum=[];
           if(this.queueId){
             this.queueNum=this.queueId.split(",");
           }
           if(this.phone){
             this.title="编辑VIP";
           }
         }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/CTIConfigure/MemberEditOrAddPop.vue